import BaseModel from '@launchpad/logic/model/BaseModel';

export default class MemberFileRowModel extends BaseModel {
  /**
   * Get Method
   */
  getMethod(): string {
    return 'GET';
  }

  /**
   * Get list url
   */
  getListUrl(params: any): any {
    return `admin/tnbank/priority-pass/members-files/${params.id}/rows`;
  }

  /**
   * Get default table columns
   */
  getTableColumns(): any {
    return [
      {
        name: 'id',
        label: 'Id',
        sortable: false,
        type: 'field',
      },
      {
        name: 'name',
        label: 'Name',
        sortable: false,
        type: 'field',
      },
      {
        name: 'additionalData.Email',
        label: 'E-mail',
        sortable: false,
        type: 'field',
      },
      {
        name: 'memberNumber',
        label: 'Membership number',
        sortable: false,
        type: 'field',
      },
      {
        name: 'token',
        label: 'Token',
        sortable: false,
        type: 'field',
      },
      {
        name: null,
        label: 'Actions',
        sortable: false,
        type: 'actions',
      },
    ];
  }
}
